import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';


export default function ChannelChart  ({ data , title = "asd" }) {

    const { t, i18n } = useTranslation();
 // --- Colors for the bars ---
  const COLORS = ['#0D6EFD', '#FD7E14']; // Bootstrap Primary and Orange

  // Calculate the total value from the data prop.
  const totalValue = data.reduce((acc, entry) => acc + entry.value, 0);

  // --- Custom Legend Component (Internal to ChannelChart) ---
  const CustomLegend = () => (
    <div className="w-100 w-md-25 p-2">
    
      <ul className="list-unstyled mt-3">
        {data.map((entry, index) => (
          <li key={`legend-${index}`} className="d-flex justify-content-between align-items-center mb-2 small">
            <div className="d-flex align-items-center">
              <span
                className="d-inline-block rounded-circle me-2"
                style={{ width: '12px', height: '12px', backgroundColor: COLORS[index % COLORS.length] }}
              ></span>
              <span className="text-muted">{entry.name}</span>
            </div>
            <div className="d-flex align-items-center">
                <span className="fw-medium text-dark me-4">{entry.value.toLocaleString()}</span>
                <span className="text-muted text-end" style={{width: '60px'}}>
                    {((entry.value / totalValue) * 100).toFixed(2)}%
                </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="shadow mb-3">
      <div className="p-2 p-md-2">
        <div className="row g-0">
         {/* <div className="col-md-3">
            <CustomLegend />
          </div> */}
          {/* Chart Section */}
          <div className="col-md-12" style={{ height: '80px' }}>
      
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                layout="vertical"
                data={data}
                margin={{
                  top: 5,
                  right: 50, 
                  left: 50,
                  bottom: 5,
                }}
              >
                <XAxis type="number" hide />
                <YAxis
                  type="category"
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fill: '#6C757D', fontSize: 12 }}
                />
                <Tooltip
                  cursor={{ fill: 'rgba(248, 249, 250, 0.5)' }}
                  contentStyle={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #dee2e6',
                    borderRadius: '0.5rem',
                    boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
                  }}
                />
                <Bar dataKey="value" barSize={10} radius={[0, 5, 5, 0]}>
                  {/* Label for each bar */}
                  <LabelList
                    dataKey="value"
                    position="right"
                    offset={15}
                    style={{ fill: '#212529', fontSize: 11, fontWeight: '500' }}
                    formatter={(value) => value.toLocaleString()}
                  />
                  {/* Assign a different color to each bar */}
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          
        </div>
      </div>
    </div>
  );
};